export const QUERY_KEYS = {
  adminOptions: "adminOptions",
  restaurantOptions: "restaurantOptions",
  legalEntity: "legalEntity",
  assignment: "assignment",
  purchase: "purchase",
  collections: "collections",
  faqs: "faqs",
  property: "property",
  adminTransacions: "adminTransacions",
  countryCity: "countryCity",
  adminUsers: "adminUsers",
  adminUserRole: "adminUserRole",
  checkInviteToken: "checkInviteToken",
  partnerScopeUsers: "partnerScopeUsers",
  adminTransactionDetails: "adminTransactionDetails",
  adminVoidRequests: "adminVoidRequests",
  adminCorrectionRequests: "adminCorrectionRequests",
  adminPosSettlements: "adminPosSettlements",
  creditReporting: "creditReporting",
  topUpsReporting: "topUpsReporting",
  settlementOverview: "settlementOverview",
  adminSettlementTransfers: "adminSettlementTransfers",
  adminCashbackOverrides: "adminCashbackOverrides",
  locationData: "locationData",
  allUsersRoles: "allUsersRoles",
  brandFundingStatistic: "brandFundingStatistic",

  // admin diners
  diners: "diners",
  dinerBrand: "dinerBrand",
  dinerBranch: "dinerBranch",
  dinerTiers: "dinerTiers",
  referralRules: "referralRules",
  dinersTopUps: "dinersTopUps",
  dinerReferralInsightsSummary: "dinerReferralInsightsSummary",
  dinerReferralInsightMembers: "dinerReferralInsightMembers",

  // groups
  group: "group",
  groups: "groups",
  groupFunding: "groupFunding",
  groupFundingConsumption: "groupFundingConsumption",

  // brands
  brands: "brands",
  brandAvailableLegalEntity: "brandAvailableLegalEntity",
  brandFundingApplication: "brandFundingApplication",
  brandFundingConsumption: "brandFundingConsumption",

  // branches
  branches: "branches",
  branchPosIntegration: "branchPosIntegration",
  branchFoodicsAuthorizationToken: "branchFoodicsAuthorizationToken",
  branchAvailableLegalEntity: "branchAvailableLegalEntity",
  branchExcludedItems: "branchExcludedItems",

  // branches restaurants
  branchTransactions: "branchTransactions",
  branchTransactionsStats: "branchTransactionsStats",
  branchTransactionsToday: "branchTransactionsToday",
  branchTransactionsAll: "branchTransactionsAll",
  branchTransactionsStatsTotal: "branchTransactionsStatsTotal",

  // brands restaurants
  brandTransactions: "brandTransactions",
  brandTransactionsStats: "brandTransactionsStats",
  brandTransactionsTotal: "brandTransactionsTotal",
  brandTransactionsStatsTotal: "brandTransactionsStatsTotal",

  // groups restaurants
  groupTransactions: "groupTransactions",
  groupTransactionsStats: "groupTransactionsStats",

  // business management
  businessManagement: "businessManagement",

  // restaurant overview statistics
  restaurantStatistics: "restaurantStatistics",

  // restaurant funding
  restaurantFundings: "restaurantFundings",
  restaurantFundingsConsumption: "restaurantFundingsConsumption",

  // restaurant partners (users)
  restaurantUsers: "restaurantUsers",

  //restaurant diners
  restaurantGroupDiners: "restaurantGroupDiners",
  restaurantBrandDiners: "restaurantBrandDiners",
  restaurantBranchDiners: "restaurantBranchDiners",
  restaurantAllBrandDiners: "restaurantAllBrandDiners",
  restaurantAllBranchDiners: "restaurantAllBranchDiners",

  localeInfo: "localeInfo",

  accountsDashboard: "accountsDashboard",
  dinersDashboard: "dinersDashboard",
  settlementsDashboard: "settlementsDashboard",
  transactionsDashboard: "transactionsDashboard",
  adminOverviewDashboard: "adminOverviewDashboard",
  adminTeams: "adminTeams",
  checkInviteTeamToken: "checkInviteTeamToken",
  allTeamRoles: "allTeamRoles",
  auditLog: "auditLog",
  entityHistory: "entityHistory",
  adminAssignment: "adminAssignment",
  checkResetPasswordAdminToken: "checkResetPasswordAdminToken",
  foodicsBrands: "foodicsBrands",
};

export const LOGIN_TOKEN = "spice-token";
export const REFRESH_TOKEN = "spice-refresh-token";

export const RESPONSE_STATUSES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  BAD_REQUEST: 400,
  UNPROCESSABLE_ENTITY: 422,
  NO_CONTENT: 204,
  DEFAULT_ERROR: "NETWORK_ERROR",
};

export const RESPONSE_ANSWERS = {
  BAD_REQUEST: "Bad request",
  INVALID_ID: "INVALID_ID",
};

export const AUDIT_LOG_TYPE_KEYS = {
  FAQ: "FAQ",
  PORTAL_USER_ROLE: "PORTAL_USER_ROLE",
  TAGS: "TAG",
  SETTLEMENT_TRANSFER: "SETTLEMENT_TRANSFER",
  CORRECTION_REQUEST: "CORRECTION_REQUEST",
};
